<div class="medication-request-status-modal">
  <div class="modal-header">
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body">
    <div class="info">
      <h3>{{prescriptionTypeId == prescriptionFulfillmentTypeEnum.Medicine ?  'Medications' : 'Radiologies'}} Request Status</h3>
      <h4>Adjust below status according to the request progress.</h4>
    </div>
    <div class="status-container">
      <div class="form-group">
        <input
          type="radio"
          name="medication-request-status"
          id="inprogress"
          [value]="prescriptionRequestStatusEnum.InProgress"
          (change)="onStatusChange($event.target.value)"
          [checked]="!isInProgress"
          [attr.disabled]="isInProgress ? '' : null"
        />
        <label for="inprogress">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="51.322"
            height="49.412"
            viewBox="0 0 51.322 49.412"
          >
            <g
              id="noun-history-support-2607592"
              transform="translate(-125.798 -64.199)"
            >
              <path
                id="Path_28628"
                data-name="Path 28628"
                d="M165.552,379.959a.979.979,0,0,1-.457-.224,5.4,5.4,0,0,1-.555-.555.66.66,0,0,0-.979,0,5.409,5.409,0,0,1-.553.554.979.979,0,0,1-.459.226,1.89,1.89,0,0,0-.811.411,1.627,1.627,0,0,0-.543,1.015c-.034.176-.044.209-.107.27-.105.1-.213.117-.519.136a2.055,2.055,0,0,0-1.346.471,1.75,1.75,0,0,0-.547.923,1.738,1.738,0,0,1-.2.479,2.573,2.573,0,0,1-1.534.991.636.636,0,0,0,.18,1.247h13.857a.637.637,0,0,0,.181-1.247,2.615,2.615,0,0,1-1.532-.987,1.774,1.774,0,0,1-.2-.484,1.753,1.753,0,0,0-.546-.923h0a2.059,2.059,0,0,0-1.347-.471c-.306-.019-.414-.034-.519-.135-.063-.062-.074-.1-.107-.271a1.633,1.633,0,0,0-.545-1.018,1.889,1.889,0,0,0-.81-.409Zm1.9,3.1a.875.875,0,0,1,.588.159c.087.077.1.123.164.328a3.012,3.012,0,0,0,.346.8,2.934,2.934,0,0,0,.2.281h-9.41a2.867,2.867,0,0,0,.207-.286,2.985,2.985,0,0,0,.343-.8c.061-.205.077-.251.165-.328a.875.875,0,0,1,.588-.159,1.894,1.894,0,0,0,1.328-.495,1.616,1.616,0,0,0,.469-.941c.035-.178.043-.22.135-.3a.653.653,0,0,1,.311-.14,2.216,2.216,0,0,0,.947-.487c.076-.065.147-.13.213-.192.066.062.137.127.213.193a2.217,2.217,0,0,0,.946.486.652.652,0,0,1,.309.138c.1.084.1.126.137.3a1.617,1.617,0,0,0,.47.942,1.9,1.9,0,0,0,1.327.494Z"
                transform="translate(-27.022 -278.809)"
                fill="#3b3e51"
                stroke="#fff"
                stroke-width="0.4"
              />
              <path
                id="Path_28629"
                data-name="Path 28629"
                d="M170.307,269.876l2.5.965a.642.642,0,0,0,.23.043.633.633,0,0,0,.23-.043l2.486-.961a6.228,6.228,0,0,0,.847-.392l.016-.009a2,2,0,0,0,.184-.1,7.627,7.627,0,0,0,3.8-6.583.636.636,0,0,0-1.071-.465,5.128,5.128,0,0,1-2.887,1.605c-.12.01-.234.015-.337.015a6.972,6.972,0,0,1-.867-.079,3.626,3.626,0,0,0-2.014.142c-.087.037-.171.074-.252.111a6.3,6.3,0,0,0-.993.582,2.028,2.028,0,0,1-.968.437,2.631,2.631,0,0,1-.919,0,6.823,6.823,0,0,0-1.016-.075,3.62,3.62,0,0,0-2.443,1.077.636.636,0,0,0-.106.823,7.469,7.469,0,0,0,3.582,2.908Zm-1.033-3.534a5.647,5.647,0,0,1,.846.064,3.81,3.81,0,0,0,1.285,0,3.255,3.255,0,0,0,1.493-.645,5.01,5.01,0,0,1,.8-.474c.07-.032.146-.065.211-.093a2.465,2.465,0,0,1,1.355-.055,8.173,8.173,0,0,0,1.029.09q.215,0,.452-.02a5.163,5.163,0,0,0,2.4-.945,6.358,6.358,0,0,1-3,4.019l-.008,0a.533.533,0,0,1-.075.041.628.628,0,0,0-.152.08,4.9,4.9,0,0,1-.622.282l-2.267.876-2.269-.877a6.148,6.148,0,0,1-2.634-1.948,2.032,2.032,0,0,1,1.146-.4Z"
                transform="translate(-36.004 -175.284)"
                fill="#3b3e51"
                stroke="#fff"
                stroke-width="0.4"
              />
              <path
                id="Path_28630"
                data-name="Path 28630"
                d="M176.915,89.224a5.256,5.256,0,0,0-2.611-3.895v-4.6A16.352,16.352,0,0,0,157.97,64.4h-5.232a16.308,16.308,0,0,0-16.262,14.9h-9.841a.637.637,0,0,0-.637.637V83.73a.636.636,0,0,0,.637.637h.309v3.147a10.186,10.186,0,0,0,5.194,8.842,10.184,10.184,0,0,0-5.194,8.842v3.149h-.309a.637.637,0,0,0-.637.637v3.791a.636.636,0,0,0,.637.637h20.787a.637.637,0,0,0,.637-.637v-3.791a.636.636,0,0,0-.637-.637h-.309V105.2a10.183,10.183,0,0,0-5.194-8.842q.26-.145.513-.307a10.067,10.067,0,0,0,4.681-8.535V84.367h.311a.637.637,0,0,0,.637-.637V79.937a.636.636,0,0,0-.637-.637h-5.709a11.147,11.147,0,0,1,11.023-9.707h5.232A11.152,11.152,0,0,1,169.11,80.733v4.633a5.272,5.272,0,0,0-2.617,4.565v5.156a5.227,5.227,0,0,0,3.267,4.869v3.96a3.946,3.946,0,0,1-3.941,3.941h-2.781a2.145,2.145,0,0,0-1.735-1.342,31.14,31.14,0,0,0-7.748-.033,2.358,2.358,0,0,0-2.107,2.325v2.053a2.16,2.16,0,0,0,.026.343,2.384,2.384,0,0,0,2.084,1.982,31.153,31.153,0,0,0,7.746-.034,2.139,2.139,0,0,0,1.757-1.407h2.757a7.839,7.839,0,0,0,7.83-7.83V99.993c.1-.036.192-.073.28-.114.008,0,.015-.011.024-.015a5.206,5.206,0,0,0,2.961-4.079.521.521,0,0,0,.006-.079V89.3a.675.675,0,0,0,0-.079Zm-15,19.365v2.5a.866.866,0,0,1-.773.8,29.845,29.845,0,0,1-7.427.032,1.109,1.109,0,0,1-.979-.918.886.886,0,0,1-.011-.143v-2.053a1.017,1.017,0,0,1,.021-.194,1.107,1.107,0,0,1,.968-.868,29.868,29.868,0,0,1,7.43.032.864.864,0,0,1,.771.8h0c0,.006,0,.012,0,.018Zm-15.13,1.03v2.518H127.27v-2.518Zm-.945-22.105a8.8,8.8,0,0,1-4.093,7.462,8.663,8.663,0,0,1-1.551.786.636.636,0,0,0,0,1.188,8.884,8.884,0,0,1,5.645,8.248v3.149H128.216V105.2a8.885,8.885,0,0,1,5.645-8.248.637.637,0,0,0,0-1.188,8.885,8.885,0,0,1-5.645-8.248V84.366h17.622Zm.948-6.941v2.521H127.271V80.573Zm25.59,23.341a6.565,6.565,0,0,1-6.557,6.557h-2.633v-1.343h2.633a5.22,5.22,0,0,0,5.214-5.214V100.3a5,5,0,0,0,.58.033h.236a4.958,4.958,0,0,0,.528-.027Zm.653-5.051c-.069.023-.146.047-.228.071a.124.124,0,0,0-.013,0,.562.562,0,0,0-.075.016,2.959,2.959,0,0,1-.36.071,3.653,3.653,0,0,1-.507.036h-.236a3.478,3.478,0,0,1-1.042-.154,3.945,3.945,0,0,1-2.8-3.818V89.93a3.99,3.99,0,0,1,2.257-3.621,3.666,3.666,0,0,1,1.588-.363h.236a3.688,3.688,0,0,1,.534.044l.129.021a3.707,3.707,0,0,1,.519.13h0Zm0-14.048c-.019,0-.038-.006-.056-.01-.123-.029-.247-.049-.372-.068-.063-.01-.124-.024-.187-.031a4.936,4.936,0,0,0-.568-.034h-.236a4.913,4.913,0,0,0-.588.037c-.062.008-.123.022-.185.032-.133.021-.266.044-.4.076-.02,0-.04.006-.059.011v-4.1a12.426,12.426,0,0,0-12.412-12.412h-5.232A12.433,12.433,0,0,0,140.42,79.3H137.75a15.039,15.039,0,0,1,14.988-13.628h5.232a15.076,15.076,0,0,1,15.059,15.06Zm2.617,10.85a3.973,3.973,0,0,1-1.343,2.479V86.868a4,4,0,0,1,1.343,2.478Z"
                transform="translate(0)"
                fill="#3b3e51"
                stroke="#fff"
                stroke-width="0.4"
              />
            </g>
          </svg>
          <h4>Request is In Progress</h4>
          <p>
            Select this status when you have contacted with the pharmacy &
            request is being processed.
          </p>
        </label>
      </div>
      <div class="form-group">
        <input
          type="radio"
          name="medication-request-status"
          id="finished"
          [value]="prescriptionRequestStatusEnum.Finished"
          (change)="onStatusChange($event.target.value)"
          [checked]="isInProgress"
        />
        <label for="finished">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="39.556"
            height="50.957"
            viewBox="0 0 39.556 50.957"
          >
            <g id="noun-check-1596055" transform="translate(-159.198 -33.199)">
              <path
                id="Path_28631"
                data-name="Path 28631"
                d="M160.631,33.6a1.181,1.181,0,0,0-1.033,1.14V45a1.14,1.14,0,1,0,2.28,0V35.881h25.077V43.86a1.184,1.184,0,0,0,1.14,1.14h7.979V81.476h-34.2V49.56a1.14,1.14,0,1,0-2.28,0V82.616a1.185,1.185,0,0,0,1.14,1.14h36.476a1.185,1.185,0,0,0,1.14-1.14V43.86a1.154,1.154,0,0,0-.338-.8L188.9,33.94a1.154,1.154,0,0,0-.8-.338H160.632Zm28.6,3.882,5.236,5.236h-5.236Zm-.142,18.9a1.15,1.15,0,0,0-.659.338L175.556,69.6l-6.038-6.038a1.14,1.14,0,1,0-1.6,1.621l6.839,6.839a1.184,1.184,0,0,0,1.6,0l13.678-13.678a1.14,1.14,0,0,0-.944-1.959Z"
                transform="translate(0)"
                fill="#3b3e51"
                stroke="#fff"
                stroke-width="0.8"
              />
            </g>
          </svg>
          <h4>Request is Finished</h4>
          <p>Select this status when medicines are delivered successfully.</p>
        </label>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary text-white"
      (click)="onMedicationRequestStatusSubmit()"
    >
      Update Status
    </button>
  </div>
</div>
